var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mql-breadcrumb" },
    [
      _c(
        "el-breadcrumb",
        { staticClass: "app-breadcrumb", attrs: { separator: "/" } },
        [
          _c(
            "transition-group",
            { attrs: { name: "breadcrumb" } },
            _vm._l(_vm.levelList, function(item, index) {
              return item.meta.title
                ? _c("el-breadcrumb-item", { key: item.path }, [
                    item.redirect === "noredirect" ||
                    index == _vm.levelList.length - 1
                      ? _c("span", { staticClass: "no-redirect" }, [
                          _vm._v(_vm._s(item.meta.title))
                        ])
                      : _c(
                          "a",
                          {
                            staticClass: "redirect",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleLink(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.meta.title))]
                        )
                  ])
                : _vm._e()
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mql-breadcrumb__right" },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96806dde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96806dde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/MqlLayout/MqlBreadcrumb/index.vue
// module id = null
// module chunks = 